import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getClinicHairServiceMasterByClinicId } from "../../../../store/slices/clinicHairServiceMaster";
import Select from "react-select";

const HealthScreening = ({ handleChange, isClient }) => {
  const [selectedHairServices, setSelectedHairServices] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const dispatch = useDispatch();
  const { clinicHairServiceMasterByClinicId } = useSelector(
    (state) => state.clinicHairServiceMaster,
  );
  const { token } = useSelector((state) => state.auth);
  const clinicId = clinicInfo?.[0]?.clinicId || null;
  useEffect(() => {
    dispatch(
      getClinicHairServiceMasterByClinicId({
        clinicId,
        token,
      }),
    );
  }, [dispatch, clinicId, token]);

  const handleSelectedHairService = (selectedOptions) => {
    setSelectedHairServices(selectedOptions || []);
    handleChange(
      (selectedOptions || []).map((option) => ({
        id: option.value,
        name: option.label,
        price: option.price,
        type: option.type,
      })),
      "serviceDetails",
    );
  };

  useEffect(() => {
    if (!selectedHairServices.length) return;

    const updatedServices = selectedHairServices.map((option) => {
      const servicePrice =
        clinicHairServiceMasterByClinicId?.[0]?.services?.find(
          (serv) => serv._id === option.value,
        );

      return {
        ...option,
        price:
          isClient === "Yes"
            ? servicePrice?.client_price
            : servicePrice?.pt_price,
      };
    });

    setSelectedHairServices(updatedServices);
    handleChange(
      updatedServices.map((option) => ({
        id: option.value,
        name: option.label,
        price: option.price,
        type: option.type,
      })),
      "serviceDetails",
    );
  }, [isClient]);

  useEffect(() => {
    const totalAmount = selectedHairServices?.reduce((sum, option) => {
      return sum + (option.price || 0);
    }, 0);

    setTotalAmount(totalAmount);
  }, [selectedHairServices]);

  return (
    <>
      <div className="col-xl-6">
        <div className="form-group">
          <label htmlFor="name" className="col-form-label">
            Service Details:
          </label>
          <Select
            options={
              clinicHairServiceMasterByClinicId &&
              clinicHairServiceMasterByClinicId[0]?.services
                ?.filter((servicedetails) => servicedetails.status === "Active")
                ?.map((servicedetails) => ({
                  value: servicedetails?._id,
                  label: servicedetails?.serviceDetailName,
                  type: "hair",
                  price:
                    isClient === "Yes"
                      ? servicedetails?.client_price
                      : servicedetails?.pt_price,
                }))
            }
            value={selectedHairServices}
            onChange={handleSelectedHairService}
            isMulti
            styles={{
              container: (provided) => ({ ...provided, marginTop: 8 }),
            }}
          />
        </div>
      </div>
      <div className="col-xl-6">
        <div className="form-group">
          <label htmlFor="total-amount" className="col-form-label">
            Total Amount:
          </label>
          <input
            type="number"
            className="form-control"
            id="total-amount"
            value={totalAmount}
            readOnly
          />
        </div>
      </div>
    </>
  );
};

export default HealthScreening;
